export default __webpack_public_path__ + "assets/342a68d551d32ddc9f648761d4a8b9c1.jpg";